/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { collaboratorControllerCreatePayment } from '../fn/collaborator/collaborator-controller-create-payment';
import { CollaboratorControllerCreatePayment$Params } from '../fn/collaborator/collaborator-controller-create-payment';
import { TransactionDto } from '../models/transaction-dto';

@Injectable({ providedIn: 'root' })
export class CollaboratorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `collaboratorControllerCreatePayment()` */
  static readonly CollaboratorControllerCreatePaymentPath = '/collaborator/payment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `collaboratorControllerCreatePayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  collaboratorControllerCreatePayment$Response(params: CollaboratorControllerCreatePayment$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDto>> {
    return collaboratorControllerCreatePayment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `collaboratorControllerCreatePayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  collaboratorControllerCreatePayment(params: CollaboratorControllerCreatePayment$Params, context?: HttpContext): Observable<TransactionDto> {
    return this.collaboratorControllerCreatePayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionDto>): TransactionDto => r.body)
    );
  }

}
